import { render, staticRenderFns } from "./DialogProduct.vue?vue&type=template&id=c6d275a8&scoped=true&"
import script from "./DialogProduct.vue?vue&type=script&lang=js&"
export * from "./DialogProduct.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/sass/style_custom.scss?vue&type=style&index=0&id=c6d275a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d275a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6d275a8')) {
      api.createRecord('c6d275a8', component.options)
    } else {
      api.reload('c6d275a8', component.options)
    }
    module.hot.accept("./DialogProduct.vue?vue&type=template&id=c6d275a8&scoped=true&", function () {
      api.rerender('c6d275a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Products/DialogProduct.vue"
export default component.exports